import { ResponseMapper } from '../../utils/httpclient/response/responsemapper';
import { BuyToneRequest } from '../api/tune/buytune/buytonerequest';
import { BuyToneResponse, BuyToneResponseDtoImpl } from '../api/tune/buytune/buytoneresponse';
import { APIFeatures } from '../util/apifeatures';
import { StatusCodes } from '../util/statuscodes';
import { Strings } from '../../utils/resources/strings';
import { APIProcessorImpl } from './apiProcessor';

export class BuyToneNonLoggedInUserAPIProcessorImpl extends APIProcessorImpl<BuyToneRequest, BuyToneResponse>
{
    execute(request: BuyToneRequest): void 
    {
        super.execute(request);
    }

    onSuccess(responseMapper: ResponseMapper): void 
    {
        super.onSuccess(responseMapper);
        try {

            if (+responseMapper.getStatusCode() === StatusCodes.SUCCESS) {

                let response = new BuyToneResponseDtoImpl(APIFeatures.BUY_TONE, 
                    this.getContext().getResources().getString(Strings.your_order_is_successfully_completed));

                this.getAPISuccess(response);
            }
        }
        catch (e) {
            this.getAPIFailure(new BuyToneResponseDtoImpl(APIFeatures.BUY_TONE, this.getContext().getResources().getString(Strings.internal_server_error)));
        }
    }

    onFailure(responseMapper: ResponseMapper): void 
    {
  
        this.getAPIFailure(new BuyToneResponseDtoImpl(APIFeatures.BUY_TONE, responseMapper.getStatusMsg()));
        
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/processor/buytonenonloggedinuserapiprocessor.tsx